import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PenOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.86675 14.1334L1.86675 11.7831L9.40071 4.2491L11.751 6.59939L4.21704 14.1334H1.86675ZM12.5995 5.75086L13.6467 4.70374C14.2957 4.05472 14.2957 3.00246 13.6467 2.35345C12.9976 1.70443 11.9454 1.70443 11.2964 2.35345L10.2492 3.40057L12.5995 5.75086ZM0.666748 15.3334L0.666749 11.286L10.4478 1.50492C11.5655 0.387276 13.3775 0.387276 14.4952 1.50492C15.6128 2.62256 15.6128 4.43462 14.4952 5.55227L4.7141 15.3334H0.666748Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const PenOutlinedSize16 = hoc(forwardRef(PenOutlinedSize16Component), 'PenOutlinedSize16');

export { PenOutlinedSize16 as default };
//# sourceMappingURL=PenOutlinedSize16.js.map
